




























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { institutionServer, patrolManagementServe, spaceServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import { cloneObj } from '@/util/tree';
import { TableStripe } from '@/mixins/tableStripe';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import PagingUnit from '@/components/paging/paging.vue'; // 分页

@Component({
  components: {
    CollapseTransition,
    PagingUnit,
  },
  mixins: [TableStripe],
})
export default class PlanIndex extends Vue {
  @Prop(Object) page!: any; // 从父组件接受过来一行的数据
  private planList: any = [];
  private clonePlanList: any = [];
  searchFlag = false; // 控制显示 查询和隐藏查询
  // 搜索表单数据
  formData: any = {
    name: '', // 机构名称
    scheduleName: '', // 机构名称
    deptId: '', // 所属单位
  };
  queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 总共多少条数据
  subSpaceByAuthOptions: any = [];

  private created() {
    this.queryDataForm = this.page;
    this.getSubSpaceByAuth();
    this.getPlanList();
  }

  private mounted() {}

  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getDeptAndSubDeptList({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   *【接口】获取排班方案分页数据
   * @Params
   * @return
   **/
  async getPlanList() {
    const res: any = await patrolManagementServe.getPatrolScheduleList({
      pageNo: this.queryDataForm.pageNo,
      pageSize: this.queryDataForm.pageSize,
      name: this.formData.name ? this.formData.name : null,
      scheduleName: this.formData.scheduleName ? this.formData.scheduleName : null,
      deptId: this.formData.deptId ? this.formData.deptId : null,
    });
    if (res.code === '200') {
      this.planList = res.data.records;
      this.total = res.data.total;
      this.clonePlanList = cloneObj(res.data);
    }
  }

  /**
   * @desc 点击隐藏和显示按钮触发，控制表单搜索内容是否显示
   */
  setFormShow() {
    this.searchFlag = !this.searchFlag;
  }

  /**
   * @desc 点击编辑机构触发，跳转到编辑机构页面
   * @param1 row：该行数据
   * @returns 暂无
   */
  editOrgan(rowId: string, type: any) {
    this.$emit('getRow', rowId, type); // 将 row 传递给编辑机构页面
    this.$emit('update:show', false); // 跳到编辑机构页面
    this.$emit('update:editOrganFlag', 1); // 跳转到编辑机构页面
  }

  /**
   * @desc 点击新增按钮，跳转到新增机构页面
   * @param1 暂无
   * @returns 暂无
   */
  addOrgan(type: any) {
    this.$emit('getRow', '', type); // 传递空字符串给新增机构页面
    this.$emit('update:show', false); // 跳到新增机构页面
    this.$emit('update:editOrganFlag', 3); // 跳转到新增页面
  }

  /**
   *【接口】删除排班方案
   * @Params
   * @return
   **/
  async deletePlanData(id: any) {
    this.$confirm('此操作将永久删除该方案, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        patrolManagementServe.deletePatrolSchedule(id).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('删除成功！');
            this.queryDataForm.pageNo = 1;
            this.getPlanList();
          } else {
            this.$message.error(res.msg);
          }
        });
      })
      .catch(() => {});
  }

  /**
   * @desc 分页切换
   */
  getListData() {
    this.getPlanList();
  }

  /**
   * @desc 条件搜索
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    this.getPlanList();
  }

  /**
   * @desc 分页重置
   */
  resetForm() {
    (this.$refs.formRef as any).resetFields();
    // 获取全部数据
    (this.queryDataForm as any).pageNo = 1;
    this.getPlanList();
  }
}
